export default __webpack_public_path__ + "static/media/Ethereum1.c72020fc.png";